<template>
  <section v-loading.fullscreen.lock="loading" class="noticeDto">
    <div v-if="articleData&&articleData.title">
      <div class="titleBox">
        <div class="title">
          {{ articleData.title }}
        </div>
        <div class="date">
          <span style="margin-right:10px">创建时间: </span>
          <span> {{ articleData.created_date }}</span>
        </div>
      </div>
      <div class="noticeDto-content">
        <el-scrollbar wrap-style="overflow-x: hidden;">
          <div class="coontent" v-html="articleData.content" />
        </el-scrollbar>
      </div>
    </div>
    <div v-else class="nullData">
      <NullData
        text="审核通过"
      />
    </div>
  </section>
</template>

<script>
import { articleDataApi } from '@/api/library'

import NullData from '@/components/NullData'

import { mapGetters } from 'vuex'
export default {
  components: {
    NullData
  },
  data() {
    return {
      loading: false,
      articleData: null
      // NullData
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    })
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      this.loading = true
      articleDataApi({
        school_id: this.user.school_id
      }).then((res) => {
        this.loading = false
        this.articleData = res.data[0]
        console.log(res, 'res', true)
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.noticeDto {
  @include fun-layout(1);
  height: 100%;
  .titleBox{
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    -webkit-box-shadow: 0px 0px 4px 3px rgba(85, 85, 85, 0.03);
    box-shadow: 0px 0px 4px 3px rgba(85, 85, 85, 0.03);
    padding: 10px 20px;
    .title{
       font-family: "Microsoft YaHei";
      color: #333;
      font-weight: bold;
      text-align: center;
      font-size: 26px;
    }
    .date{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      padding-top: 19px;
      font-family: "Microsoft YaHei";
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
  }
  &-content {
    height: calc(100% - 106px);
    @include fun-layout(2);
    margin-top: 20px;
    padding: 20px;
  }
}
.coontent {
  padding-bottom: 50px;
}
.nullData{
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>
